import { idbGet, idbRemove, idbSet } from './indexedDb';

// JSON serialization wrapper around IndexedDB.
// All data is stored exclusively in IndexedDB with consistent JSON handling.

export async function setIndexDbData(
  key: string,
  value: unknown,
): Promise<void> {
  const str = JSON.stringify(value ?? {});
  await idbSet(key, str);
}

export async function getIndexDbData(key: string): Promise<unknown | null> {
  const fromIndexedDb = await idbGet(key);

  if (fromIndexedDb != null) {
    return JSON.parse(fromIndexedDb);
  }

  return null;
}

export async function removeIndexDbData(key: string): Promise<void> {
  await idbRemove(key);
}
